var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ArcGISGeoJsonLoader {
    /**
     * Get properties with field types
     *
     * @param properties
     * @param templateFields
     */
    getTemplateProperties(properties, templateFields) {
        var _a;
        const output = {};
        for (const field of templateFields) {
            if (field.name in properties) {
                const key = `${field.name} (${field.type})`;
                const value = properties[field.name];
                output[key] = (_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : null;
            }
        }
        return output;
    }
    /**
     * Get default properties
     *
     * @param properties
     */
    getDefaultProperties(properties) {
        return {
            name: `Annotation-${properties.OBJECTID}`,
            fill: '#FFFFFF',
            stroke: '#FFFFFF',
            'marker-color': '#F69C64',
            'stroke-width': 2,
            'fill-opacity': 0.5,
        };
    }
    /**
     * Get feature collection
     *
     * @param json
     * @param templateFields
     */
    read(json, templateFields) {
        return __awaiter(this, void 0, void 0, function* () {
            const raw = JSON.parse(json);
            const featureCollection = {};
            featureCollection['type'] = raw.type;
            featureCollection['features'] = raw.features.map((feature) => ({
                id: feature.id,
                geometry: feature.geometry,
                type: feature.type,
                properties: Object.assign(Object.assign({}, this.getDefaultProperties(feature.properties)), this.getTemplateProperties(feature.properties, templateFields)),
            }));
            return featureCollection;
        });
    }
}
